import { Component } from '@angular/core';

@Component({
    selector: 'rwidget-related-cards-empty-state',
    templateUrl: './related-cards-empty-state.component.html',
    styleUrls: ['./related-cards-empty-state.component.scss'],
})
export class RelatedCardsEmptyStateComponent {}
